<template>
    <div class="home-proj-item">
      <div class="home-proj-content" v-if="loaded && ready" :class="{'case1': numScreen === 1}">

        <div  class="home-proj-media-aux" :id="'home-proj-media-aux' + numScreen" v-on:click="goRoute()" v-on:mouseover="controlDragTool(1)" v-on:mouseout="controlDragTool(6)">
          <media-type :className="'home-proj-media'" :obj="projData.cover" :dynAlt="projData.title[0].name"> </media-type>
        </div>


        <div class="home-proj-info">
          <div class="home-proj-tags">
            <span class="home-proj-tags-item" v-for="(item, index) in projData.tags">{{item.name[lang].name}} <span v-if="index < (projData.tags.length - 1)"> / </span></span>
          </div>
          <h1 class="home-proj-title">{{projData.title[0].name}}</h1>
          <div class="home-proj-pagination">
            <span>{{numScreen}}</span>
            <span>{{totalScreen}}</span>
          </div>

        </div>


        <div :id="'dragme' + numScreen"  class="dragme" :class="{'ver' : dragToolMode == 1, 'hide' : dragToolMode == 6 }">

          <span class="" >  VER CASE    </span>

        </div>

      </div>

    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {

        name: 'home-proj-module',
      components: {MediaType},
      props: ['projId',  'lang', 'actScreen', 'totalScreen', 'numScreen', 'scroll'],
        data() {
            return {
                projData: [],
                loaded: false,
                 ready: false,
                visited: false,
              dragToolMode: 6,
              el :{}


            }
        },

        created() {
          const _this = this;
          PROJ('id', this.projId, function (response){

            _this.projData = response[0];
            _this.loaded = true;
            _this.init();
            console.log( _this.projData)

          });


        },
      mounted() {

        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);


        this.ready = true;
        this.init();



        EVENTBUS.$on('handOnOff', this.handOnOff);
        EVENTBUS.$on('animCase', this.animCase);
      },

        destroyed() {
          this.el.removeEventListener( "mousemove",  this.navigationDrag2, false );
          this.el.removeEventListener( "touchmove",  this.touchDrag2, false );
        },

        methods: {


              //EVENTBUS.$on('AAA', AAA);
              //EVENTBUS.$emit('AAA', 0);

          controlDragTool(n){

            this.dragToolMode = n;

          },


          touchDrag2(e){
            this.navigationDrag2(e.touches[0]);

          },

          navigationDrag2(e) {

            var dec = 0

            TweenMax.to( '#dragme' + this.numScreen, .3, { x:   e.clientX, y: e.clientY , force3D: true, ease: Power2.easeOut} );

          },

            init(){
              const _this = this;
              if(this.loaded && this.ready){

                setTimeout(function (){
                  _this.el = document.getElementById('home-proj-media-aux' + _this.numScreen);

                  _this.el.addEventListener( "mousemove",  _this.navigationDrag2, false );
                  _this.el.addEventListener( "touchmove",  _this.touchDrag2, false );





                }, 110);






                if(this.numScreen === 1){

                 //   this.animCase();
                }else{
                  this.visited = true;
                }

              }
            },

          animCase(){
              const _this = this;
            if(_this.numScreen === 1 && _this.loaded && _this.ready && !_this.visited){


              setTimeout(function (){
                TweenMax.to( '.case1 .home-proj-media',1, { x: 0,  force3D: true, ease: "circ.Out"} );
                TweenMax.to( '.case1 .home-proj-info',1.2, { x: 0, y:0, force3D: true, ease: "circ.Out"} );
                TweenMax.to( '.case1 .home-proj-media',0.5, {delay: 0.5, width: '85%',  force3D: true, ease: "circ.In", onComplete:function() {
                    _this.visited =  true;

                    $('.case1').removeClass('case1')
                  }} );



              }, 1);



            }


          },

          handOnOff(b){

              if(this.visited){
                if(b){


                  TweenMax.to( '.home-proj-info', 0.3, { y: '100px',  scale:0.7, opacity: 0.4, force3D: true, ease: "circ.inOut"} );
                  TweenMax.to( '.home-proj-media', 0.3, { scale:0.7,  force3D: true, ease: "circ.inOut"} );
                }else{
                  TweenMax.to( '.home-proj-info', 0.7, { y: '0px', scale:1, opacity: 1, force3D: true, ease: "circ.out"} );
                  TweenMax.to( '.home-proj-media', 0.7, { scale: 1, force3D: true, ease: "circ.out"} );
                }
              }



           // TweenMax.to( '.sub-headline', 1, { x: pos2 +'%' , force3D: true, ease: "circ.out"} );

          },

          goRoute(){
            console.log(this.scroll)
            if(this.scroll == 0) {
               // alert('dfdsf')
              }


            this.$router.push('project/' + this.projData.route);
          }


        },






    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/HomeProjModule.vue